export default __webpack_public_path__ + "static/media/30.2b93118b.jpg";